import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Link } from 'react-router-dom';

const styles = {
  icons: {
    color: '#22467F',
    size: 'small',
  },
};

const Sidebar = () => (
  <List sx={{ width: '100%', maxWidth: 360 }} component="nav">
    <ListItem disablePadding>
      <ListItemButton component={Link} to="/admin/users">
        <ListItemIcon>
          <ListAltIcon sx={styles.icons} />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </ListItemButton>
    </ListItem>
    <ListItem disablePadding>
      <ListItemButton component={Link} to="/admin/requests">
        <ListItemIcon>
          <ManageAccountsIcon sx={styles.icons} />
        </ListItemIcon>
        <ListItemText primary="Requests" />
      </ListItemButton>
    </ListItem>
    <ListItem disablePadding>
      <ListItemButton component={Link} to="/admin/invite">
        <ListItemIcon>
          <PendingActionsIcon sx={styles.icons} />
        </ListItemIcon>
        <ListItemText primary="Invites" />
      </ListItemButton>
    </ListItem>
  </List>
);
export default Sidebar;
